import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María G.',
    info: '34 años, Buenos Aires',
    text: 'Me hackearon mi cuenta de Instagram donde vendo ropa. Estaba desesperada. Gracias a la guía de recuperación pude volver a entrar en menos de 48hs. Ahora tengo todo configurado como enseñan y me siento mucho más tranquila. ¡Vale cada peso!'
  }, {
    name: 'Carlos R.',
    info: '45 años, Córdoba',
    text: 'No soy muy bueno con la tecnología y siempre tenía miedo de hacer clic donde no debía. Este material es súper claro, te lleva de la mano. Lo leí en un fin de semana y ya aseguré mis cuentas del banco y WhatsApp.'
  }, {
    name: 'Luciana M.',
    info: '28 años, Rosario',
    text: 'Casi caigo en una estafa por mail que parecía idéntica a mi banco. Si no hubiera leído el bono de las 20 estafas reales, hubiera perdido mis ahorros. Información vital que todos deberíamos saber hoy en día.'
  }, {
    name: 'Jorge P.',
    info: '52 años, Mendoza',
    text: 'Compré la colección para entender cómo proteger a mi familia en internet. Me sorprendió lo fácil que es de entender. Ya le pasé los tips a mis hijos para que configuren bien su privacidad en redes sociales.'
  }, {
    name: 'Valentina S.',
    info: '31 años, La Plata',
    text: 'Como emprendedora, mi negocio depende 100% de mis redes. El libro sobre cómo proteger tu negocio de Instagram es oro puro. Apliqué todo paso a paso. Excelente inversión, lo recomiendo a todos mis colegas.'
  }];
  return <section className="bg-[#0B0B1A] py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-183">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-[#FF00FF] opacity-8 blur-[150px] rounded-full pointer-events-none" data-id="element-184" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-185">
        <h2 className="text-3xl md:text-5xl font-extrabold text-center text-white mb-16" data-id="element-186">
          Lo que dicen quienes ya protegieron sus cuentas
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-187">
          {testimonials.map((t, i) => <div key={i} className="bg-white/5 p-8 rounded-2xl border border-white/10 flex flex-col backdrop-blur-sm" data-id="element-188">
              <div className="flex gap-1 mb-4" data-id="element-189">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-[#FFD700] text-[#FFD700]" data-id="element-190" />)}
              </div>
              <p className="text-gray-300 text-lg italic mb-6 flex-grow" data-id="element-191">
                "{t.text}"
              </p>
              <div className="border-t border-white/10 pt-4 mt-auto" data-id="element-192">
                <p className="font-bold text-[#00D4FF]" data-id="element-193">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-194">{t.info}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}